import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

import { setCustomRoomName as setRoomName } from '~/actions/room'
import { setRoomInputError } from '~/actions/ui'
import { joinCustomRoom as join } from '~/actions/active-session'
import JoinRoomButton from '~/components/buttons/join-room'
import { translate } from '~/core/translate'
import { JOIN_TYPES, KEY_CODES } from '~/core/constants'
import { ColumnFlexCentered } from './common/containers'
import Input from './common/input'
import { getIsJoinButtonDisabled, getRoomInputHasError } from '~/selectors/ui'
import { getCustomRoomName } from '~/selectors/room'

const RelativeContainer = styled.div`
  margin-bottom: 20px;
  position: relative;
  width: 100%;
`

const Error = styled.span`
  font-size: ${({ theme }) => theme._neo.label01.fontSize};
  color: ${props => props.theme.colorError};
  margin-top: 4px;
`

const JoinCustomRoom = ({
  customRoomName,
  hasError,
  buttonDisabled,
  setCustomRoomName,
  setInputError,
  joinCustomRoom,
  joinButtonLabel
}) => {
  const onKeyPress = e => {
    if (e.charCode === KEY_CODES.ENTER) {
      joinCustomRoom({ value: customRoomName })
    }
  }

  return (
    <ColumnFlexCentered fullWidth data-test-id='enter-room-name'>
      <RelativeContainer>
        <Input
          focus
          placeholder={translate('hint_join_simple')}
          hasError={hasError}
          value={customRoomName}
          onChange={e => setCustomRoomName(e.target.value)}
          onKeyPress={onKeyPress}
          onFocus={() => setInputError(false)}
          maxLength={640}
        />
        {hasError && <Error>{translate('wrong_meeting_name')}</Error>}
      </RelativeContainer>
      <JoinRoomButton
        isDisabled={buttonDisabled || !customRoomName}
        joinArgs={{ value: customRoomName }}
        joinType={JOIN_TYPES.CUSTOM}
      >
        {joinButtonLabel}
      </JoinRoomButton>
    </ColumnFlexCentered>
  )
}

JoinCustomRoom.defaultProps = {
  joinButtonLabel: translate('join')
}

const mapStateToProps = state => ({
  hasError: getRoomInputHasError(state),
  buttonDisabled: getIsJoinButtonDisabled(state),
  customRoomName: getCustomRoomName(state)
})

const mapDispatchToProps = dispatch => ({
  setCustomRoomName: value => dispatch(setRoomName(value)),
  setInputError: value => dispatch(setRoomInputError(value)),
  joinCustomRoom: args => dispatch(join(args))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(JoinCustomRoom)
